type PriceMatrixLike = {
  prices?: Record<string, unknown>;
  pricesByCountry?: Record<string, Record<string, unknown>>;
  priceKeys?: string[];
  priceValuesByCountry?: Record<string, unknown[]>;
  fallbackCountry?: string;
} | null | undefined;

const priceKeyIndexes = new WeakMap<object, Map<string, number>>();

/**
 * Selecteert de prijsmatrix voor het daadwerkelijke afleverland. Producten
 * zonder landmatrices houden exact het bestaande gedrag via `prices`.
 */
export function resolvePriceMatrixPrices(
  priceMatrix: PriceMatrixLike,
  countryCode?: string | null,
): Record<string, unknown> {
  const requestedCountry = String(countryCode || '').trim().toUpperCase();
  const fallbackCountry = String(priceMatrix?.fallbackCountry || 'NL').trim().toUpperCase();
  const countryMatrices = priceMatrix?.pricesByCountry;

  return countryMatrices?.[requestedCountry]
    || countryMatrices?.[fallbackCountry]
    || priceMatrix?.prices
    || {};
}

/** Compacte clientmatrices bewaren per land alleen een waardenkolom die is
 * uitgelijnd met `priceKeys`; servermatrices mogen het volledige object houden.
 */
export function resolvePriceMatrixPrice(
  priceMatrix: PriceMatrixLike,
  countryCode: string | null | undefined,
  key: string,
): unknown {
  const country = String(countryCode || '').trim().toUpperCase();
  const fallbackCountry = String(priceMatrix?.fallbackCountry || 'NL').trim().toUpperCase();
  const direct = priceMatrix?.pricesByCountry?.[country]?.[key]
    ?? priceMatrix?.pricesByCountry?.[fallbackCountry]?.[key];
  if (direct !== undefined) return direct;

  const values = priceMatrix?.priceValuesByCountry?.[country]
    ?? priceMatrix?.priceValuesByCountry?.[fallbackCountry];
  const keys = priceMatrix?.priceKeys || Object.keys(priceMatrix?.prices || {});
  if (Array.isArray(values) && Array.isArray(keys) && priceMatrix && typeof priceMatrix === 'object') {
    let indexes = priceKeyIndexes.get(priceMatrix);
    if (!indexes) {
      indexes = new Map(keys.map((matrixKey, index) => [matrixKey, index]));
      priceKeyIndexes.set(priceMatrix, indexes);
    }
    const index = indexes.get(key);
    if (index !== undefined && values[index] !== undefined) return values[index];
  }

  return priceMatrix?.prices?.[key];
}
